<template>
  <div>
    <div class="head-box">
      <h4>服务协议</h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称/编码"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增服务协议</el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="服务协议" :visible.sync="openDetail" destroy-on-close @closed="doInit">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        @changeForm="osg.changeForm"
      >
        <template slot="contactsId">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="formData.contactsId"
            :fetch-suggestions="getContacts"
            placeholder="可输入姓名搜索"
            @select="selectContact"
            hide-loading
            value-key="name"
          >
            <template slot-scope="{ item }">
              <p class="c-flex c-flex-between">
                <span>{{ item.name }}</span>
                <span>{{ item.phone }}</span>
              </p>
            </template>
          </el-autocomplete>
        </template>
        <template slot="userId">
          <el-select
            v-model="formData.userId"
            filterable
            remote
            placeholder="可输入姓名搜索"
            :remote-method="getUsers"
          >
            <el-option
              v-for="item in options.users"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="bizType">
          <el-select v-model="formData.bizType" @change="formData.bizId = ''">
            <el-option
              v-for="item in options.serviceAgreementBizType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="bizId" v-if="formData.bizType == '1'">
          <el-select
            v-model="formData.bizId"
            filterable
            remote
            clearable
            placeholder="可输入工单标题/编号/姓名/手机号搜索"
            :remote-method="getServiceAppointments"
          >
            <el-option
              v-for="item in options.serviceAppointments"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span style="float: left">{{ item.orderNum }}</span>
              <span style="float: right">{{ item.name }}:{{ item.phone }}</span>
            </el-option>
          </el-select>
        </template>
        <template slot="bizId" v-else>
          <el-select
            v-model="formData.bizId"
            filterable
            remote
            clearable
            placeholder="可输入合同编号/委托方/委托方手机号搜索"
            :remote-method="getContracts"
          >
            <el-option
              v-for="item in options.contracts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span style="float: left">{{ item.contractdocNum }}</span>
              <span style="float: right">{{ item.contactsName }}:{{ item.contactsPhone }}</span>
            </el-option>
          </el-select>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ServiceAgreements',
  data() {
    window.$this = this;
    return {
      name: 'serviceAgreement',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        biz: '',
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_unit: { codeId: 'UNIT' }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('serviceAgreement', () => {
      this.osg.getFpi();
      this.getData();
      // this.getContacts();
      this.getUsers();
      this.getServiceAppointments();
      this.getContracts();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      if (this.$refs['formData']) {
        this.$refs['formData'].resetFields();
      }
      this.upload.data = {};
      this.formData = { bizId: '', exts: {} };
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/serviceAgreement/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        // 赋值
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = Object.assign({}, row); //避免编辑内容后取消导致显示异常
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      let row = this.$util.deepCopy(this.formData);
      this.$util.saveExtField(this.extFields, row);
      if (this.osg.validate()) {
        this.osg.ajax('basic/serviceAgreement/upsert.do', row, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/serviceAgreement/changeState.do', { id, state: 1 }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/serviceAgreement/changeState.do', { id, state: 0 }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('basic/serviceAgreement/changeState.do', { id, state: -1 }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    getContacts(searchVal, cb) {
      this.osg.ajax(
        'basic/contacts/query.do',
        { page: 1, rows: 20, 'regex:name|string#and': searchVal },
        res => {
          if (cb) {
            cb(res.data);
          }
        },
        {
          noload: true
        }
      );
    },
    selectContact(item) {
      this.$set(this.formData, 'contactsIds', item._id);
      this.$set(this.formData, 'contactsName', item.name);
      this.$set(this.formData, 'contactsPhone', item.phone);
    },
    getUsers(searchVal) {
      this.osg.ajax(
        'user/query.do',
        { page: 1, rows: 20, 'is:state|integer#and': 1, 'regex:name|string#and': searchVal },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getServiceAppointments(searchVal) {
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        {
          page: 1,
          rows: 20,
          'is:state|integer#and': 1,
          'regex:title|string#or': searchVal,
          'regex:orderNum|string#or': searchVal,
          'regex:name|string#or': searchVal,
          'regex:phone|string#or': searchVal
        },
        res => {
          res.data.map(item => {
            item.label = item.title;
            item.value = item._id;
          });
          this.options.serviceAppointments = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getContracts(searchVal) {
      this.osg.ajax(
        'basic/contract/query.do',
        {
          page: 1,
          rows: 20,
          'is:state|integer#and': 1,
          'regex:contractdocNum|string#or': searchVal,
          'regex:contactsName|string#or': searchVal,
          'regex:contactsPhone|string#or': searchVal
        },
        res => {
          res.data.map(item => {
            item.label = item.contractdocNum;
            item.value = item._id;
          });
          this.options.contracts = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    }
  }
};
</script>
